const GrayButton = (props) => {
    const { children, size, ...otherProps } = props;

    let className = "relative whitespace-nowrap inline-block hover:cursor-pointer bg-gray-100 px-2 md:px-6 outline-none text-base text-gray-800 rounded-xl md:rounded-2xl transition duration-200 hover:bg-gray-200 active:bg-gray-200 dark:bg-navy-800 dark:border dark:border-gray-700 dark:text-white dark:hover:bg-navy-700 dark:active:bg-navy-600";
    className += (size === 'sm' ? ' h-8' : (size === 'lg' ? ' h-10' : ' h-12') );

    return (
        <button {...otherProps} className={className}>
            {children}
        </button>
    );
};

export default GrayButton;

